import { createUrlWithSourceQueryParams } from '@crehana/analytics';
import { useTranslation } from '@crehana/i18n';
import { ArrowRight } from '@crehana/icons/outline';
import { Col, Container, PrimaryButton, Row, TextLink } from '@crehana/ui';

import {
  BackgroundContainer,
  StyledBackground,
  StyledH2,
} from './PreFooter.styles';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const registerUrl = createUrlWithSourceQueryParams({
    url: '/onboarding/',
    source: 'Homepage',
    sourceDetail: 'Prefooter',
  });

  const b2bUrl = createUrlWithSourceQueryParams({
    url: '/onboarding/b2b/name/',
    source: 'Homepage',
    sourceDetail: 'Prefooter',
  });
  return (
    <section className="overflow-hidden pt-104">
      <Container>
        <Row>
          <Col className="text-center sm:pb-72 md:pb-48">
            <StyledH2 className="font-h2 text-32 leading-40 md:text-52 md:leading-64  sm:m-auto">
              {t('PREFOOTER_TITLE')}
            </StyledH2>
            <h4 className="font-body2 my-16 sm:my-32">
              {t('PREFOOTER_SUBTITLE')}
            </h4>
            <div className="flex flex-col sm:flex-row w-full justify-center items-center">
              <PrimaryButton
                as="a"
                href={registerUrl}
                htmlProps={{ 'aria-label': t('PREFOOTER_CTA') }}
                className="rounded-10 mb-20 sm:mb-0 sm:mr-32"
              >
                {t('PREFOOTER_CTA')}
              </PrimaryButton>
              <TextLink
                as="a"
                href={b2bUrl}
                className="text-primary-main hover:text-primary-lighter"
                rightIcon={{ component: ArrowRight }}
              >
                {t('PREFOOTER_LINK')}
              </TextLink>
            </div>
          </Col>
        </Row>
      </Container>
      <BackgroundContainer className="relative">
        <StyledBackground />
      </BackgroundContainer>
    </section>
  );
};

export default Footer;
